import React, { useEffect, useState } from "react";

/**
 * Live SLA timer — ticks every second.
 * Green 0–5 min, amber 5–15 min, red 15+.
 * If acknowledged_at is set, freezes to "Acknowledged" green.
 */
export default function SlaTimer({ createdAt, acknowledgedAt, size = "sm" }) {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        if (acknowledgedAt) return;
        const t = setInterval(() => setNow(Date.now()), 1000);
        return () => clearInterval(t);
    }, [acknowledgedAt]);

    if (acknowledgedAt) {
        return (
            <span
                className="inline-flex items-center gap-1.5 rounded-full bg-emerald-100 px-2.5 py-0.5 text-[11px] font-medium text-emerald-800"
                data-testid="sla-timer-acknowledged"
            >
                <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
                Acknowledged
            </span>
        );
    }

    const createdMs = new Date(createdAt).getTime();
    const diffMs = Math.max(0, now - createdMs);
    const mins = Math.floor(diffMs / 60000);
    const secs = Math.floor((diffMs % 60000) / 1000);
    const label = `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;

    let tone = "bg-emerald-100 text-emerald-800 border-emerald-200";
    let dot = "bg-emerald-500";
    if (mins >= 15) {
        tone = "bg-red-100 text-red-800 border-red-200";
        dot = "bg-red-500 animate-pulse";
    } else if (mins >= 5) {
        tone = "bg-amber-100 text-amber-900 border-amber-200";
        dot = "bg-amber-500";
    }

    const pad = size === "lg" ? "px-3 py-1 text-xs" : "px-2.5 py-0.5 text-[11px]";

    return (
        <span
            className={`inline-flex items-center gap-1.5 rounded-full border font-medium tabular-nums ${tone} ${pad}`}
            data-testid="sla-timer"
            title={`Opened ${mins}m ${secs}s ago`}
        >
            <span className={`h-1.5 w-1.5 rounded-full ${dot}`} />
            {label}
        </span>
    );
}
